import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { eur, fmtDate } from "@/components/common";

const MESI = ["GEN", "FEB", "MAR", "APR", "MAG", "GIU", "LUG", "AGO", "SET", "OTT", "NOV", "DIC"];

// Timeline annuale delle ricorrenze: usa ESCLUSIVAMENTE i dati già presenti
// (date programmate nel calendario di sistema + offerte/immagini del catalogo).
export default function RicorrenzeTimeline() {
  const [items, setItems] = useState(null);
  const [offer, setOffer] = useState(null);

  useEffect(() => {
    api.get("/ricorrenze/calendario").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <section data-testid="ricorrenze-timeline" className="max-w-6xl mx-auto px-4 sm:px-6 pb-14 sm:pb-20">
      <p className="eyebrow mb-2">Le ricorrenze dell'anno</p>
      <h2 className="font-serif text-3xl sm:text-4xl text-navy mb-8">Un pensiero speciale, in ogni stagione.</h2>
      <div className="flex gap-4 overflow-x-auto pb-3 snap-x">
        {items.map((it) => {
          const day = new Date(`${it.date}T12:00:00`);
          const active = it.in_window;
          return (
            <button
              key={it.recurrence}
              type="button"
              disabled={!active}
              onClick={() => active && setOffer(it)}
              data-testid={`ric-card-${it.recurrence}`}
              className={`snap-start shrink-0 w-36 sm:w-44 rounded-2xl border text-left overflow-hidden transition-shadow duration-200 ${
                it.passed ? "opacity-55" : ""
              } ${it.is_next ? "border-[#4a7c59] shadow-md" : "border-[#ece7dd]"} ${
                active ? "bg-white cursor-pointer hover:shadow-md" : "bg-[#faf8f3] cursor-default"
              }`}
            >
              <div className="relative">
                <img src={it.products[0]?.image} alt={it.label} className="w-full h-24 sm:h-28 object-cover" />
                {active && (
                  <span
                    data-testid={`ric-badge-${it.recurrence}`}
                    className="absolute top-2 right-2 text-[11px] font-bold text-white bg-[#4a7c59] rounded-full px-2.5 py-1"
                  >
                    {it.days_left === 0 ? "Oggi" : `Tra ${it.days_left} ${it.days_left === 1 ? "giorno" : "giorni"}`}
                  </span>
                )}
              </div>
              <div className="p-3">
                <p className="font-serif text-2xl text-navy leading-none">
                  {day.getDate()} <span className="text-sm">{MESI[day.getMonth()]}</span>
                </p>
                <p className="text-xs text-body mt-1 leading-snug">{it.label}</p>
              </div>
            </button>
          );
        })}
      </div>

      {offer && (
        <div
          className="fixed inset-0 z-[80] bg-black/50 flex items-end sm:items-center justify-center p-4"
          onClick={() => setOffer(null)}
          data-testid="ric-offer-modal"
        >
          <div className="bg-white rounded-2xl overflow-hidden max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <img src={offer.products[0]?.image} alt={offer.label} className="w-full h-52 object-cover" />
            <div className="p-6 space-y-3">
              <p className="eyebrow">{offer.label} · {fmtDate(offer.date)}</p>
              {offer.products.map((p) => (
                <div key={p.id} className="flex items-start justify-between gap-3">
                  <div>
                    <p className="font-semibold text-navy">{p.name}</p>
                    {p.description && <p className="text-xs text-muted-soft mt-0.5">{p.description}</p>}
                  </div>
                  <p className="font-serif text-2xl text-navy shrink-0">{eur(p.price)}</p>
                </div>
              ))}
              <p className="text-xs text-muted-soft">Consegna inclusa, direttamente al cimitero.</p>
              <p className="text-xs font-semibold text-[#2f5d3e] leading-relaxed">
                Se attivi un abbonamento entro 10 giorni, l'importo diventa credito sull'abbonamento (una sola volta per account).
              </p>
              <Link to={`/campagna?ricorrenza=${offer.recurrence}`} data-testid="ric-offer-cta" className="btn-primary w-full text-center block">
                Acquista ora
              </Link>
              <button type="button" onClick={() => setOffer(null)} data-testid="ric-offer-close" className="w-full text-center text-sm text-muted-soft hover:text-navy">
                Chiudi
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
